import { memo, useCallback, useMemo } from "react";
import type { Site, SiteUser } from "@src/features/settings/data/mock-sites";
import { ListRoleSelector } from "./ListRoleSelector";
import { Text, View } from "@src/components";
import { StyleSheet } from "react-native-unistyles";

type UserSitesListProps = {
  sites: Site[];
  onSiteRoleChange: (siteId: string, userId: string, role: SiteUser["role"]) => void;
  onDeleteSite?: (siteId: string) => void;
};

export const UserSitesList = memo(({ sites, onSiteRoleChange, onDeleteSite }: UserSitesListProps) => {
  const items = useMemo(
    () =>
      sites.map((site) => ({
        id: site.id,
        name: site.name,
        role: site.users[0]?.role ?? ("viewer" as const),
        _userId: site.users[0]?.id,
      })),
    [sites],
  );

  const handleRoleChange = useCallback(
    (siteId: string, role: "manager" | "viewer") => {
      const site = sites.find((s) => s.id === siteId);
      if (site?.users[0]) {
        onSiteRoleChange(siteId, site.users[0].id, role);
      }
    },
    [sites, onSiteRoleChange],
  );

  if (items.length === 0) {
    return (
      <View style={styles.emptyStateContainer}>
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          No permissions for any sites
        </Text>
      </View>
    );
  }
  return (
    <ListRoleSelector items={items} onRoleChange={handleRoleChange} onPressIcon={onDeleteSite} iconName="delete" />
  );
});

const styles = StyleSheet.create((theme) => ({
  emptyStateContainer: {
    paddingVertical: theme.spacing["5xl"],
  },
}));
